import React, { useState } from "react";

import { Link } from "react-router-dom";

export const CouponDialog = ({ handleClose, setIsCoupon }) => {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");

  const [isAlert, setIsAlert] = useState(false);
  const [msgType, setMsgType] = useState("");
  const [alertText, setAlertText] = useState("");

  const prize = localStorage.getItem("reward");

  const clearInput = () => {
    setName("");
    setMobile("");
  };

  const alertMsg = (msg, type) => {
    setAlertText(msg);
    setMsgType(type);
    setIsAlert(true);
    const timer = setTimeout(() => {
      setAlertText("");
      setMsgType("");
      setIsAlert(false);
    }, 2000);
    return () => clearTimeout(timer);
  };
  const handleCoupon = async (e) => {
    e.preventDefault();

    if (!prize) {
      alertMsg("Coupon is mandatory");
      setMsgType("warn-msg");
      return;
    }
    try {
      const mobileRegex = /^\d{10}$/;
      if (!mobileRegex.test(mobile)) {
        alertMsg(
          "Mobile number must be exactly 10 digits and contain only numbers."
        );
        setMsgType("warn-msg");
        return;
      }

      const newCoupon = {
        discount: prize,
        name: name,
        number: mobile,
      };
      const code = Math.floor(100000 + Math.random() * 900000).toString();
      setIsCoupon(code);
      clearInput();
      alertMsg("Coupon Generated Successfully");
      setMsgType("sucs-msg");
      setTimeout(() => {
        handleClose(false);
      }, 2000);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="modal-part">
      <div className="modal-section">
        <Link onClick={handleClose} className="close-modal">X</Link>
        <h2>Congratulations</h2>
        <h4>You have won {prize}% discount
        </h4>
        {isAlert && <p className={msgType}>{alertText}</p>}
        <div className="contact-form">
          <h3>Enter your details to get Coupon Code</h3>

          <form onSubmit={handleCoupon}>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="q-input"
              placeholder="Name"
              required
            />
            <input
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              name="mobile"
              type="text"
              className="q-input"
              placeholder="Number"
              required
            />
            <input
              type="submit"
              className="q-box"
              value="Submit"
            />
          </form>
        </div>
      </div>
    </div>
  );
};
